"use strict";

exports.__esModule = true;
exports["default"] = exports.RadioSwitch = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _styles = require("@qc-modules/styles");

var _styledSystem = require("styled-system");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var cursor = function cursor(_ref) {
  var disabled = _ref.disabled;
  return disabled ? "cursor: default;" : "cursor: pointer;";
};

var RadioLabel = (0, _styledComponents["default"])(_primitives["default"].Text).withConfig({
  displayName: "radio-button__RadioLabel",
  componentId: "sc-aerkw2-0"
})(["", ";", ";position:relative;", ";"], cursor, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? "opacity: 0.6;" : null;
}, _styledSystem.flexbox);
var RadioContainer = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "radio-button__RadioContainer",
  componentId: "sc-aerkw2-1"
})(["vertical-align:baseline;", ";"], (0, _styles.transitionEase)("0.3s", ["background", "border"]));
var RadioSwitch = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "radio-button__RadioSwitch",
  componentId: "sc-aerkw2-2"
})([""]);
exports.RadioSwitch = RadioSwitch;
var RadioInput = (0, _styledComponents["default"])(_primitives["default"].Input).withConfig({
  displayName: "radio-button__RadioInput",
  componentId: "sc-aerkw2-3"
})(["", ";opacity:0;position:absolute;"], cursor);
var propTypes = {
  /** Bool to set radio to disabled */
  disabled: _propTypes.bool,

  /** Bool to display as error */
  error: _propTypes.bool,

  /** Object to set font settings */
  fontObject: _utils.fontPropType,

  /** String name of radio group */
  groupName: _propTypes.string,

  /** String name of radio id */
  id: _propTypes.string,

  /** Bool to set as checked */
  isChecked: _propTypes.bool,

  /** String for radio label */
  label: _propTypes.string,

  /** Function for on change handler */
  onChange: _propTypes.func,

  /** Bool to display as success */
  success: _propTypes.bool,

  /** String for radio value */
  value: _propTypes.string
};

var RadioButton = function RadioButton(_ref3) {
  var isChecked = _ref3.isChecked,
      disabled = _ref3.disabled,
      error = _ref3.error,
      _ref3$fontObject = _ref3.fontObject,
      fontObject = _ref3$fontObject === void 0 ? _utils.defaultFontSize : _ref3$fontObject,
      id = _ref3.id,
      onChange = _ref3.onChange,
      label = _ref3.label,
      groupName = _ref3.groupName,
      success = _ref3.success,
      value = _ref3.value;
  return /*#__PURE__*/_react["default"].createElement(RadioLabel, _extends({
    color: (0, _utils.getTextColor)({
      error: error,
      success: success
    }),
    disabled: disabled,
    display: "flex",
    htmlFor: id,
    tag: "label"
  }, fontObject), /*#__PURE__*/_react["default"].createElement(RadioContainer, {
    alignItems: "center",
    backgroundColor: isChecked ? null : "background",
    border: "1px solid",
    borderColor: isChecked && !disabled ? "background-selected" : "border",
    borderRadius: "50%",
    display: "inline-flex",
    flex: "0 0 auto",
    height: 16,
    justifyContent: "center",
    mr: 1,
    width: 16
  }, isChecked ? /*#__PURE__*/_react["default"].createElement(RadioSwitch, {
    backgroundColor: disabled ? "background-light" : "background-selected",
    borderRadius: "50%",
    height: 10,
    width: 10
  }) : null), /*#__PURE__*/_react["default"].createElement(RadioInput, {
    checked: isChecked,
    disabled: disabled,
    id: id,
    name: groupName,
    onChange: onChange,
    type: "radio",
    value: value
  }), label && /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    as: "span",
    display: "inline-block"
  }, label));
};

RadioButton.propTypes = propTypes;
RadioButton.displayName = "Modules.RadioButton";
var _default = RadioButton;
exports["default"] = _default;